"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPageAutoship = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const translations_1 = require("../../i18n/translations");
const fa_1 = require("react-icons/fa");
const react_2 = require("@headlessui/react");
const react_popper_1 = require("react-popper");
const Image_1 = require("../Image");
function ProductPageAutoship(_a) {
    var { className, linkProps, linkClassName, itemFrequency, handleAutoshipFunction, removeAutoship, productId, type, locale = 'en' } = _a, props = __rest(_a, ["className", "linkProps", "linkClassName", "itemFrequency", "handleAutoshipFunction", "removeAutoship", "productId", "type", "locale"]);
    const { autoshipMonth, autoshipMonths, autoshipQuarterly, autoshipFrequencyLabel, autoshipSelectFrequency, autoshipCancelEdit, autoshipEdit, } = translations_1.cartContent[locale];
    const [autoshipFrequency, setautoshipFrequency] = (0, react_1.useState)(3);
    const [frequencyText, setFrequencyText] = (0, react_1.useState)('');
    const [referenceElement, setReferenceElement] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const [arrowElement, setArrowElement] = (0, react_1.useState)(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        placement: 'top',
        strategy: 'absolute',
        modifiers: [
            { name: 'arrow', options: { element: arrowElement, padding: 10 } },
            {
                name: 'offset',
                options: {
                    offset: [6, 6],
                },
            },
        ],
    });
    const [isChecked, setIsChecked] = (0, react_1.useState)(false);
    const toggleAutoshipInputIsOpen = (e) => {
        const checked = e.target.id;
        if (checked === 'autoship-purchase') {
            setIsChecked(true);
            handleAutoshipFunction(autoshipFrequency);
        }
        else {
            setIsChecked(false);
            removeAutoship();
        }
    };
    const handleAutoshipFrequency = (frequency) => {
        setautoshipFrequency(frequency);
        handleAutoshipFunction(frequency);
    };
    (0, react_1.useEffect)(() => {
        let text = '';
        if (itemFrequency === 'quarterly') {
            text = autoshipQuarterly;
        }
        else if (itemFrequency === '1') {
            text = `1 ${autoshipMonth}`;
        }
        else {
            text = `${itemFrequency} ${autoshipMonths}`;
        }
        setFrequencyText(text);
    }, [itemFrequency, locale]);
    (0, react_1.useEffect)(() => {
        // TODO: Is this check needed. Commented out due to causing an error.
        // setIsChecked(!!itemFrequency);
        if (itemFrequency) {
            // convert string value to number to match select values
            setautoshipFrequency(+itemFrequency);
        }
    }, [itemFrequency]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('max-w-xs text-sm rounded-xl border-2 border-gray mb-4 p-4', 'break-inside-avoid') },
        react_1.default.createElement("label", { htmlFor: "one-time-purchase", className: "relative w-full block" },
            react_1.default.createElement("input", { id: "one-time-purchase", name: "pdp-autoship", type: "radio", defaultChecked: true, onChange: toggleAutoshipInputIsOpen, className: "absolute top-0.5 rounded-full checked:ring-blue checked:accent-blue checked:text-blue\n        focus:ring-blue focus:bg-blue checked:bg-blue hover:checked:bg-blue hover:checked:text-blue" }),
            react_1.default.createElement("div", { className: "w-full flex justify-between pl-8" },
                react_1.default.createElement("p", { className: "pr-2" }, "One-time purchase"),
                react_1.default.createElement("p", { className: "pl-2" }, "$3.75"))),
        react_1.default.createElement("label", { htmlFor: "autoship-purchase", className: "relative w-full block mt-4" },
            react_1.default.createElement("input", { id: "autoship-purchase", className: "absolute top-0.5 rounded-full checked:ring-blue checked:accent-blue checked:text-blue\n          focus:ring-blue focus:bg-blue checked:bg-blue hover:checked:bg-blue hover:checked:text-blue", name: "pdp-autoship", type: "radio", onChange: toggleAutoshipInputIsOpen, "data-testid": `autoship-checkbox-${productId}` }),
            react_1.default.createElement("div", { className: "w-full flex justify-between pl-8 text-yellow-autoship" },
                react_1.default.createElement("p", { className: "pr-2 flex" },
                    react_1.default.createElement("span", { className: "mr-2" },
                        react_1.default.createElement(Image_1.Image, { className: "h-4 relative top-0.5", src: "/as-logo-icon-91x70?fmt=png-alpha", alt: "", "aria-hidden": true })),
                    react_1.default.createElement("span", null, "Autoship and Save 5%"),
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_2.Popover, { as: "span", className: "relative inline-block relative top-0.5" }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_2.Popover.Button, { ref: (e) => setReferenceElement(e), className: "text-blue hover:text-blue-hover transition-colors relative underline hover:no-underline focus:no-underline font-semibold ml-2" },
                                react_1.default.createElement(fa_1.FaQuestionCircle, { "aria-label": "Need more information?" })),
                            react_1.default.createElement(react_2.Transition, { show: open, as: "span", enter: "transition duration-200 ease-out w-full", enterFrom: "transform opacity-0", enterTo: "transform opacity-100", leave: "transition duration-200 ease-out w-full", leaveFrom: "transform opacity-100", leaveTo: "transform opacity-0", className: "z-[2001]", static: true },
                                react_1.default.createElement(react_2.Popover.Panel, Object.assign({ static: true, className: "popper-panel z-[2001]" // z-index so high due to cartPane being 2000
                                    , ref: (e) => setPopperElement(e), style: styles.popper }, attributes.popper),
                                    react_1.default.createElement("div", { className: "popper-arrow", ref: (e) => setArrowElement(e), style: styles.arrow }),
                                    react_1.default.createElement("div", { className: "block bg-white shadow-md-all rounded-lg text-sm p-4 py-2 w-64 text-gray border border-[#f4f4f4]" },
                                        react_1.default.createElement("p", { className: "mb-2" }, "Save 5% on Autoship orders paid with your organization's billing account, or 3% paid by credit card."),
                                        react_1.default.createElement("p", null,
                                            react_1.default.createElement("a", { href: "/en/special-emphasis/autoship", className: "link" }, "learn more")))))))))),
                react_1.default.createElement("p", { className: "pl-2" }, "$3.75"))),
        type === 'Custom Frequency' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)('text-sm pl-8 mt-2 md:mb-0', {
                    hidden: !isChecked,
                }) },
                react_1.default.createElement("label", { className: "mr-3", htmlFor: "autoship-frequency-select" }, "Delivery Every:"),
                react_1.default.createElement("select", { id: "autoship-frequency-select", className: "inline-block rounded border border-borderColor mr-4 text-sm mb-1 py-1.5 pl-3 pr-10", onChange: (e) => handleAutoshipFrequency(e.target.value), value: autoshipFrequency },
                    react_1.default.createElement("option", { value: 1 },
                        "1 ",
                        autoshipMonth),
                    react_1.default.createElement("option", { value: 3 },
                        "3 ",
                        autoshipMonths),
                    react_1.default.createElement("option", { value: 6 },
                        "6 ",
                        autoshipMonths),
                    react_1.default.createElement("option", { value: 9 },
                        "9 ",
                        autoshipMonths),
                    react_1.default.createElement("option", { value: 12 },
                        "12 ",
                        autoshipMonths)))))));
}
exports.ProductPageAutoship = ProductPageAutoship;
